import React, { useMemo } from 'react';

interface HelperPrompt {
  id: string;
  pillText: string;
  inputTemplate: string;
}

interface HelperPromptsProps {
  onPromptClick: (template: string) => void;
}

/* const HELPER_PROMPTS: HelperPrompt[] = [
  // Location basics
  {
    id: 'weather',
    pillText: 'Weather check',
    inputTemplate: 'What\'s the weather like in '
  },
  {
    id: 'hotels',
    pillText: 'Where to stay?',
    inputTemplate: 'Find places to stay in '
  },
  {
    id: 'transport',
    pillText: 'Getting around',
    inputTemplate: 'How to get around in '
  },
  {
    id: 'attractions',
    pillText: 'Must-see places',
    inputTemplate: 'What are the must-see places in '
  },
  {
    id: 'hidden-gems',
    pillText: 'Hidden gems',
    inputTemplate: 'Show me hidden gems in '
  },
  
  // Food & Drink
  {
    id: 'restaurants',
    pillText: 'Places to eat',
    inputTemplate: 'Recommend best restaurants in '
  },
  {
    id: 'street-food',
    pillText: 'Best street food',
    inputTemplate: 'Show me best street food place in '
  },
  {
    id: 'cafes',
    pillText: 'Coffee spots',
    inputTemplate: 'Show me best cafes in '
  },
  
  // Activities
  {
    id: 'photos',
    pillText: 'Photo spots',
    inputTemplate: 'Recommend best photography locations in '
  },
  {
    id: 'shopping',
    pillText: 'Shopping',
    inputTemplate: 'Show me best shopping areas in '
  },
  {
    id: 'nature',
    pillText: 'Nature spots',
    inputTemplate: 'Which are the best nature spots near '
  },
  {
    id: 'walking-tours',
    pillText: 'Walking routes',
    inputTemplate: 'Suggest some walking routes in '
  },
  
  // Planning
  {
    id: 'itinerary',
    pillText: 'Plan my trip',
    inputTemplate: 'I want to plan a trip to '
  },
  {
    id: 'day-trip',
    pillText: 'Day trips',
    inputTemplate: 'Suggest best day trips from '
  },
  {
    id: 'weekend',
    pillText: 'Weekend trips',
    inputTemplate: 'Plan a weekend in '
  },
  
  // Practical info
  {
    id: 'budget',
    pillText: 'Budget planning',
    inputTemplate: "What's a typical budget for a trip to "
  },
  {
    id: 'safety',
    pillText: 'Travel safey',
    inputTemplate: 'Give me some safety tips for '
  },
  {
    id: 'tips',
    pillText: 'Local tips',
    inputTemplate: 'Give me some local tips for visiting '
  },
  {
    id: 'when-visit',
    pillText: 'Best time to visit',
    inputTemplate: 'When is the best time to visit '
  },
  {
    id: 'how-long',
    pillText: 'Trip duration',
    inputTemplate: 'How many days should I spend in '
  }
]; */

const HELPER_PROMPTS: HelperPrompt[] = [
    // Location basics
    {
      id: 'weather',
      pillText: 'Weather check',
      inputTemplate: 'What\'s the weather in '
    },
    {
      id: 'hotels',
      pillText: 'Where to stay?',
      inputTemplate: 'Find hotels in '
    },
    {
      id: 'transport',
      pillText: 'Getting around',
      inputTemplate: 'How to get around '
    },
    {
      id: 'attractions',
      pillText: 'Must-see places',
      inputTemplate: 'Show me attractions in '
    },
    {
      id: 'hidden-gems',
      pillText: 'Hidden gems',
      inputTemplate: 'Find hidden gems in '
    },
    
    // Food & Drink
    {
      id: 'restaurants',
      pillText: 'Places to eat',
      inputTemplate: 'Find restaurants in '
    },
    {
      id: 'street-food',
      pillText: 'Best street food',
      inputTemplate: 'Where to find street food in '
    },
    {
      id: 'cafes',
      pillText: 'Coffee spots',
      inputTemplate: 'Best coffee shops in '
    },
    
    // Activities
    {
      id: 'photos',
      pillText: 'Photo spots',
      inputTemplate: 'Best photo spots in '
    },
    {
      id: 'shopping',
      pillText: 'Shopping',
      inputTemplate: 'Where to shop in '
    },
    {
      id: 'nature',
      pillText: 'Nature spots',
      inputTemplate: 'Nature activities near '
    },
    {
      id: 'walking-tours',
      pillText: 'Walking routes',
      inputTemplate: 'Walking tours in '
    },
    
    // Planning
    {
      id: 'itinerary',
      pillText: 'Plan my trip',
      inputTemplate: 'Plan my trip to '
    },
    {
      id: 'day-trip',
      pillText: 'Day trips',
      inputTemplate: 'Day trips from '
    },
    {
      id: 'weekend',
      pillText: 'Weekend trips',
      inputTemplate: 'Plan a weekend in '
    },
    
    // Practical info
    {
      id: 'budget',
      pillText: 'Budget planning',
      inputTemplate: 'Travel budget for '
    },
    {
      id: 'flights',
      pillText: 'Flight status',
      inputTemplate: 'Get me flight status for '
    },
    {
      id: 'safety',
      pillText: 'Travel safety',
      inputTemplate: 'Safety tips for '
    },
    {
      id: 'tips',
      pillText: 'Local tips',
      inputTemplate: 'Local tips for '
    },
    {
      id: 'when-visit',
      pillText: 'Best time to visit',
      inputTemplate: 'Best time to visit '
    },
    {
      id: 'how-long',
      pillText: 'Trip duration',
      inputTemplate: 'How long to stay in '
    }
  ];

export const HelperPrompts: React.FC<HelperPromptsProps> = ({ onPromptClick }) => {
/*   // Show a subset of prompts randomly
  const visiblePrompts = React.useMemo(() => {
    const shuffled = [...HELPER_PROMPTS].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 4);
  }, []); */

  const visiblePrompts = useMemo(() => {
    return [...HELPER_PROMPTS].sort(() => 0.5 - Math.random());
  }, []);

  return (
    <div className="flex flex-wrap gap-2" style={{ 
      marginLeft: '0',
      marginRight: '0',
      paddingLeft: '0',
      paddingRight: '0',
      width: '100%'
    }}>
      {visiblePrompts.map((prompt) => (
        <button
          key={prompt.id}
          onClick={() => onPromptClick(prompt.inputTemplate)}
          className="inline-flex items-center gap-1 px-2 py-1 text-gray-600 bg-gray-100 
                    rounded-full hover:bg-gray-200 transition-colors"
          style={{ fontSize: 'var(--action-button-text-size)' }}
        >
          <span>{prompt.pillText}</span>
        </button>
      ))}
    </div>
  );
};